import { ContactData as ContactDataDto } from 'src/Libs/user/models/user.model'
import { OwnerLocationOfInstallation } from '../../../installation-details/models'

const ownerOfInstallationDtoToModelTransformer = (value: ContactDataDto): OwnerLocationOfInstallation => ({
  adress: value.Address || '',
  country: value.Land || '',
  email: value.Email || '',
  fax: value.Telefax || '',
  gpsLatitude: value.gpsLatitude || 0,
  gpsLongitude: value.gpsLongitude || 0,
  id: value.ID || 0,
  lastUpdate: value.lastUpdate || '',
  phone: value.Telefon || '',
  zip: value.PLZ || '',
  city: value.city || '',
  emailChange: value.emailChange || '',
  emailChangeExpireDate: value.emailChangeExpireDate || '',
  street: value.PlaceOR || '',
})

export default ownerOfInstallationDtoToModelTransformer
